import * as fromRoot from '@app/reducer';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAuth from './auth';

export interface State extends fromRoot.State {
  auth: fromAuth.State;
}

export interface AuthState {
  auth: fromAuth.State;
}

export function authReducer(state, action) {
  return fromAuth.reducer(state, action);
}

export const reducers: ActionReducerMap<AuthState> = {
  auth: authReducer
};

export const authState = createFeatureSelector<State>('auth');

export const selectAuthState = createSelector(
  authState,
  (state: State) => state.auth
);

export const getLoggedIn = createSelector(
  selectAuthState,
  fromAuth.getLoggedIn
);

export const getAuthError = createSelector(
  selectAuthState,
  fromAuth.getAuthError
);

export const getUser = createSelector(
  selectAuthState,
  fromAuth.getUser
);
